enum MembershipSelectionEnum {
  OneMonth = 'one-month-membership',
  OneYear = 'one-year-membership',
  CurrentMember = 'current-member',
}

export default MembershipSelectionEnum;
